// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Documents_wrap__26sYJ","header":"Documents_header__1jR3N","body":"Documents_body__2I5hO","footer":"Documents_footer__lFHMk"};